import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import type { Location } from "fhir/r3"

type FetchLocationProps = {
  locationId?: string
  token?: string | null
}

export async function fetchLocation({ locationId, token }: FetchLocationProps): Promise<Location> {
  const response = await fetch(`/api/location/${locationId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.ok) {
    const location = await response.json()
    return location as Location
  }

  throw Error("location fetch failed")
}

export const useLocationQuery = ({ locationId, token }: FetchLocationProps): UseQueryResult<Location> =>
  useQuery({
    queryKey: ["location", locationId],
    queryFn: async () => await fetchLocation({ locationId, token }),
    enabled: !!token && !!locationId,
  })
